import { dispatchAction } from '@ardoq/rxbeach';
import { setFilterTerm as setFilterTermAction } from './actions';
import { SidebarPanelCommands } from 'canvas/sidebarPanel/types';
import { sidebarPanelCommands } from 'canvas/sidebarPanel/sidebarPanelCommands';
import {
  APIViewpointAttributes,
  ComponentSelection,
  GroupType,
  TraversalPathMatchingType,
  ViewIds,
  viewpointToTraversalBase,
} from '@ardoq/api-types';
import { openTraversalInVisualization } from 'viewpointBuilder/openTraversalInVisualization';
import { trackEventV2 } from 'tracking/tracking';
import { debounce } from 'lodash';
import { isDefaultOverview } from 'viewpoints/defaultOverview';

export type ViewpointSelectionSource = 'panel' | 'toolbar-dropdown';

export type SetNewViewpointArgs = {
  viewpoint: APIViewpointAttributes;
  componentSelection: ComponentSelection;
  source: ViewpointSelectionSource;
  isFirstOpenedTraversal: boolean;
};

export type ViewPointSwitcherCommands = {
  setFilterTerm: (filterTerm: string) => void;
  setNewViewpoint: (args: SetNewViewpointArgs) => void;
} & SidebarPanelCommands;

const TRACKING_DEBOUNCE_TIME = 1000;

const debouncedTrackViewpointSearch = debounce(() => {
  trackEventV2({ event: 'Viewpoints Panel0 Search bar used' });
}, TRACKING_DEBOUNCE_TIME);

const setFilterTerm = (term: string) => {
  dispatchAction(setFilterTermAction(term));
  debouncedTrackViewpointSearch();
};

const setNewViewpoint = ({
  viewpoint,
  componentSelection,
  source,
  isFirstOpenedTraversal,
}: SetNewViewpointArgs) => {
  trackEventV2({
    event:
      source === 'toolbar-dropdown'
        ? 'Viewpoint Toolbar0 Priority viewpoint selected'
        : 'Viewpoints Panel0 Viewpoint selected',
  });
  if (isDefaultOverview(viewpoint)) {
    openTraversalInVisualization({
      executeViewpointConfig: {
        type: 'EXECUTE_UNSAVED_VIEWPOINT',
        componentSelection,
        filters: {},
        viewName: ViewIds.MODERNIZED_BLOCK_DIAGRAM,
        paths: viewpoint.paths,
        groupBys: [
          {
            type: GroupType.WORKSPACE,
          },
          {
            type: GroupType.PARENT_ALL,
          },
        ],
        pathMatching: TraversalPathMatchingType.LOOSE,
        pathCollapsingRules: [],
        clearCurrentState: true,
        context: 'VIEWPOINT_SELECTED',
      },
      traversal: null,
      isFirstOpenedTraversal,
    });
  } else {
    openTraversalInVisualization({
      executeViewpointConfig: {
        type: 'EXECUTE_SAVED_VIEWPOINT',
        componentSelection,
        ...viewpointToTraversalBase(viewpoint),
        viewName: viewpoint.viewName,
        groupBys: viewpoint.groupBys ?? [],
        conditionalFormatting: viewpoint.conditionalFormatting ?? [],
        clearCurrentState: true,
        context: 'VIEWPOINT_SELECTED',
        viewpointId: viewpoint._id,
      },
      traversal: viewpoint,
      isFirstOpenedTraversal,
    });
  }
};

export const viewpointSwitcherCommands: ViewPointSwitcherCommands = {
  setFilterTerm,
  closePanel: sidebarPanelCommands.closePanel,
  setNewViewpoint,
};
